import * as React from 'react';
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';
import styled from '@emotion/styled';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
// import DateRangePicker from '@mui/lab/DateRangePicker';
import { DateRange } from 'react-date-range';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import moment from 'moment'
import {  TextField, Stack } from '@mui/material';
import mainContext from '../../../contexts/mainContext';

export default function Filter({ filterState, setFilterState, callFunction }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleStatusChange = (event) => {
        setFilterState({ ...filterState, fIsIllegal: event.target.value });
    };

    const handleApply = () => {
        callFunction(1);
        setAnchorEl(null);
    }

    const handleClear = () => {
        setFilterState({})
        callFunction(1, true);
        setAnchorEl(null);
    }

    return (
        <>
            <Tooltip title="Filter">
                <FilterAltIcon
                    className='pointer' style={{
                        margin: "0 1rem 0 1rem"
                    }}
                    onClick={handleClick}
                />
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <Container>
                    <FormControl>
                        <strong>By Status</strong>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            defaultValue={filterState?.fIsIllegal ? filterState?.fIsIllegal : ""}
                            onChange={handleStatusChange}
                        >
                            <FormControlLabel value="true" control={<Radio />} label="Illegal Chat" />
                            <FormControlLabel value="false" control={<Radio />} label="Legal Chat" />
                        </RadioGroup>
                    </FormControl>

                    <Divider /><br />

                

                    {/*FROM AND TO DATE PICKER*/}
                    <div className='date_div'>
                        <strong >By Date</strong>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <TextField
                                id='Date From'
                                type={"date"}
                                fullWidth
                                defaultValue={filterState.fStartDate ? moment(filterState.fStartDate).format('YYYY-MM-DD') : moment().format("YYYY-MM-DD")}
                                label="Start date"
                                onChange={(e) => {
                                    setFilterState({
                                        ...filterState,
                                        fStartDate: moment(e.target.value).format('YYYY-MM-DD')
                                    });
                                }}

                            />

                            <TextField
                                id='Date To'
                                type={"date"}
                                fullWidth
                                label="End date"
                                defaultValue={filterState.fEndDate ? moment(filterState.fEndDate).format('YYYY-MM-DD') : moment().format("YYYY-MM-DD")}
                                onChange={(e) => {
                                    setFilterState({
                                        ...filterState,
                                        fEndDate: moment(e.target.value).format('YYYY-MM-DD')
                                    });
                                }}
                            />
                        </Stack>
                    
                    </div>
                    <Divider /><br />

                    <Actions>
                        <Button variant="contained" size='small' style={{ textTransform: "unset" }} onClick={handleApply}>Apply filter</Button>
                        <Button variant="outlined" size='small' style={{ textTransform: "unset" }} onClick={handleClear}>Clear filter</Button>
                    </Actions>

                </Container>
            </Menu>
        </>
    );
}

const Container = styled("div")`
    padding: 1rem;
    .my-2{
        margin-top: 1rem;
    }
    &>.short_by{
        display: flex;
        flex-direction: column;
        &>div{
            display: flex;
            column-gap: 1rem;
        }
    }
    &>.country_select_div{
        margin-bottom: 0.5rem;
        display: flex;
        flex-direction: column;
        row-gap: 1rem;
    }
    &>.date_div{
        margin-bottom: 0.5rem;
        display: flex;
        flex-direction: column;
        row-gap: 1rem;
    }
`;

const Actions = styled("div")`
    margin-top: 1rem;
    display: flex;
    column-gap: 1rem;
`;
